var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.enemy ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Enemy')
    }
  })], 1) : _c('div', [_c('div', {
    key: "enemy-icon-".concat(_vm.enemy.m_ID),
    staticClass: "float-right px-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.ordericon.format(_vm.enemy.m_ResourceID) + '.png',
      "target": "_blank"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": _vm.$size(64)
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.ordericon.format(_vm.enemy.m_ResourceID) + '.jpg'
    }
  })], 1)], 1)]), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.enemy.m_CharaName, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.enemy.m_CharaName))])]), _c('div', {
    staticClass: "px-4 d-flex align-center"
  }, [_c('img', {
    staticClass: "d-inline",
    attrs: {
      "width": "32",
      "height": "32",
      "src": _vm.$asset.commonuiatlas.format(_vm.elementIcon) + '.png'
    }
  }), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t('Level')) + " " + _vm._s(_vm.level))])]), _c('Status', {
    staticClass: "pa-4",
    staticStyle: {
      "max-width": "320px"
    },
    attrs: {
      "status": _vm.status,
      "divide": "2"
    }
  }), _c('div', {
    staticClass: "mb-4"
  }, [_c('KeyValue', {
    staticClass: "px-4",
    attrs: {
      "k": _vm.$t('Resist Abnormals')
    }
  }), _c('v-row', {
    staticClass: "px-3",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(8, function (i) {
    return _c('v-col', {
      key: "enemy-resist-abnormals-".concat(i - 1),
      staticClass: "px-1",
      attrs: {
        "cols": "3"
      }
    }, [_c('KeyValue', {
      attrs: {
        "disabled": !_vm.enemy.m_IsRegistAbnormals[i - 1],
        "v": _vm.$t("Abnormals.".concat(i - 1))
      }
    })], 1);
  }), 1)], 1), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('AI ID'),
      "v": _vm.aiID,
      "width": "33%"
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Charge Max'),
      "v": _vm.enemy.m_CharageMax,
      "width": "33%"
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Stun Coef'),
      "v": _vm.enemy.m_StunCoef,
      "width": "33%"
    }
  }), _vm.enemy.m_StunerMag !== 1 ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Stuner Mag'),
      "v": _vm.enemy.m_StunerMag,
      "width": "33%"
    }
  }) : _vm._e(), _vm.enemy.m_StunerAvoid !== 0 ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Stuner Avoid'),
      "v": _vm.enemy.m_StunerAvoid,
      "width": "33%"
    }
  }) : _vm._e(), _vm.battleAI.m_SingleTargetPriorityWhenHateSame === 1 ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('SingleTargetPriorityWhenHateSame'),
      "v": _vm.$t("HatePriority.".concat(_vm.battleAI.m_SingleTargetPriorityWhenHateSame)),
      "width": "33%"
    }
  }) : _vm._e()], 1), _c('v-divider'), _c('Ad', {
    key: "enemy-ad-".concat(_vm.id)
  }), _vm.$s.enemyAIPattern ? [_vm.battleAI.m_ChargeCommandDatas.length == 0 ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "px-4 mb-2"
  }, [_c('v-chip', {
    key: "enemy-pattern-condition-full-charge",
    staticClass: "mr-2 mb-2"
  }, [_vm._v(_vm._s(_vm.$t('Full Charge')))])], 1), _c('Skill', {
    attrs: {
      "id": _vm.enemy.m_CharageSkillIDs[0],
      "owner": "EN",
      "sp": "",
      "element": _vm.enemy.m_Element,
      "max": "1",
      "ratio": 100
    }
  })] : _vm._e(), _vm._l(_vm.battleAI.m_ChargeCommandDatas, function (command, k) {
    return [_c('v-divider', {
      staticClass: "mb-4"
    }), _c('div', {
      staticClass: "px-4 mb-2"
    }, [_c('v-chip', {
      key: "enemy-pattern-condition-full-charge-".concat(k),
      staticClass: "mr-2 mb-2"
    }, [_vm._v(_vm._s(_vm.$t('Full Charge')))]), _vm._l(_vm.parser.conditions(command.m_Conditions, command.m_ExecNum), function (item) {
      return _c('v-chip', {
        key: "enemy-pattern-condition-full-charge-".concat(k, "-").concat(item),
        staticClass: "mr-2 mb-2"
      }, [_vm._v(_vm._s(item))]);
    })], 2), _vm._l(command.m_ExecDatas, function (exec) {
      return [_c('Skill', {
        attrs: {
          "id": _vm.enemy.m_CharageSkillIDs[exec.m_CommandIndex] === -1 ? _vm.enemy.m_CharageSkillIDs[0] : _vm.enemy.m_CharageSkillIDs[exec.m_CommandIndex],
          "owner": "EN",
          "sp": "",
          "element": _vm.enemy.m_Element,
          "max": "1",
          "ratio": exec.m_Ratio
        }
      }, [_vm.parser.singleConditions(exec.m_SingleConditions).length ? _c('div', {
        staticClass: "d-flex primary--text",
        attrs: {
          "slot": "prepend"
        },
        slot: "prepend"
      }, [_c('div', {
        staticClass: "pr-1"
      }, [_vm._v("・")]), _c('div', _vm._l(_vm.parser.singleConditions(exec.m_SingleConditions), function (item) {
        return _c('div', [_vm._v(_vm._s(item))]);
      }), 0)]) : _vm._e(), _vm.parser.flags(exec.m_AIFlags).length ? _c('div', {
        staticClass: "d-flex primary--text",
        attrs: {
          "slot": "append"
        },
        slot: "append"
      }, [_c('div', {
        staticClass: "pr-1"
      }, [_vm._v("・")]), _c('div', _vm._l(_vm.parser.flags(exec.m_AIFlags), function (item) {
        return _c('div', [_vm._v(_vm._s(item))]);
      }), 0)]) : _vm._e()])];
    })];
  }), !_vm.enemy.m_IsRegistAbnormals[0] ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "float-right pr-4"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.showConfusion = !_vm.showConfusion;
      }
    }
  }, [_vm.showConfusion ? _c('v-icon', [_vm._v("mdi-chevron-up")]) : _c('v-icon', [_vm._v("mdi-chevron-down")])], 1)], 1), _c('div', {
    staticClass: "px-4 mb-2",
    on: {
      "click": function click($event) {
        _vm.showConfusion = true;
      }
    }
  }, [_c('v-chip', {
    key: "enemy-pattern-condition-confusion",
    staticClass: "mr-2 mb-2"
  }, [_vm._v(_vm._s(_vm.$t('Abnormals.0')))])], 1), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showConfusion,
      expression: "showConfusion"
    }]
  }, _vm._l(_vm.enemy.m_SkillIDs, function (skillID, j) {
    return skillID != -1 && _vm.enemy.m_IsConfusionSkillIDs[j] ? _c('Skill', {
      key: "enemy-confusion-skill-".concat(j),
      attrs: {
        "id": skillID,
        "owner": "EN",
        "element": _vm.enemy.m_Element,
        "max": "1"
      }
    }) : _vm._e();
  }), 1)])] : _vm._e(), _vm._l(_vm.battleAI.m_PatternDatas[0].m_CommandDatas, function (command, k) {
    return [_c('v-divider', {
      staticClass: "mb-4"
    }), _c('div', {
      staticClass: "px-4 mb-2"
    }, [_vm.parser.conditions(command.m_Conditions, command.m_ExecNum).length == 0 ? _c('v-chip', {
      key: "enemy-pattern-condition-".concat(k, "-default"),
      staticClass: "mr-2 mb-2"
    }, [_vm._v(_vm._s(_vm.$t('Default')))]) : _vm._e(), _vm._l(_vm.parser.conditions(command.m_Conditions, command.m_ExecNum), function (item) {
      return _c('v-chip', {
        key: "enemy-pattern-condition-".concat(k, "-").concat(item),
        staticClass: "mr-2 mb-2"
      }, [_vm._v(_vm._s(item))]);
    })], 2), _vm._l(command.m_ExecDatas, function (exec) {
      return [_c('Skill', {
        attrs: {
          "id": _vm.enemy.m_SkillIDs[exec.m_CommandIndex],
          "owner": "EN",
          "element": _vm.enemy.m_Element,
          "max": "1",
          "ratio": exec.m_Ratio
        }
      }, [_vm.parser.singleConditions(exec.m_SingleConditions).length ? _c('div', {
        staticClass: "d-flex primary--text",
        attrs: {
          "slot": "prepend"
        },
        slot: "prepend"
      }, [_c('div', {
        staticClass: "pr-1"
      }, [_vm._v("・")]), _c('div', _vm._l(_vm.parser.singleConditions(exec.m_SingleConditions), function (item) {
        return _c('div', [_vm._v(_vm._s(item))]);
      }), 0)]) : _vm._e(), _vm.parser.flags(exec.m_AIFlags).length ? _c('div', {
        staticClass: "d-flex primary--text",
        attrs: {
          "slot": "append"
        },
        slot: "append"
      }, [_c('div', {
        staticClass: "pr-1"
      }, [_vm._v("・")]), _c('div', _vm._l(_vm.parser.flags(exec.m_AIFlags), function (item) {
        return _c('div', [_vm._v(_vm._s(item))]);
      }), 0)]) : _vm._e()])];
    })];
  }), _vm.$i18n.locale == 'zh' ? _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Page Help')))]), _c('p', {
    staticClass: "px-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('Page Helps.Enemy AI Pattern'))
    }
  })], 1) : _vm._e()] : [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Skills')))]), _vm._l(_vm.enemy.m_CharageSkillIDs, function (skillID, j) {
    return skillID != -1 ? _c('Skill', {
      key: "enemy-charge-skill-".concat(j),
      attrs: {
        "id": skillID,
        "owner": "EN",
        "element": _vm.enemy.m_Element,
        "sp": "",
        "max": "1"
      }
    }) : _vm._e();
  }), _vm._l(_vm.enemy.m_SkillIDs, function (skillID, j) {
    return skillID != -1 ? _c('Skill', {
      key: "enemy-skill-".concat(j),
      attrs: {
        "id": skillID,
        "owner": "EN",
        "element": _vm.enemy.m_Element,
        "max": "1"
      }
    }) : _vm._e();
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }